import Select from '@/shared/components/Select/Select'
import { OptionType } from '@/shared/api/BaseAPI.model'
import { selectValueType } from '@/shared/components/DynamicForm/DynamicForm'

interface TokenSelectProps {
  label: string
  value: string
  options: string[]
  translate: (value: string) => string
  onChange: (value: string) => void
}

/**
 * A choice between named tokens, which is the only kind of choice this editor
 * offers for anything that would otherwise be a number (§2 of the brief). No
 * pixels, no free text, no clear button: there is always exactly one value.
 */
function TokenSelect(props: TokenSelectProps) {
  const { label, value, options, translate, onChange } = props
  const items: OptionType[] = options.map(option => ({
    value: option,
    label: translate(option)
  }))

  const handleChange = (next: selectValueType) => {
    if (!next || Array.isArray(next)) return
    onChange(next.value)
  }

  return (
    <Select
      label={label}
      options={items}
      value={items.find(item => item.value === value) ?? null}
      onChange={handleChange}
      focused
      hideClearIcon
      readonly
    />
  )
}

export default TokenSelect
